import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {InitPaymentRequest} from "../models/payment/initPaymentRequest";
import {Observable} from "rxjs";
import {InitPaymentResponse} from "../models/payment/initPaymentResponse";
import {ProcessPaymentDetailsRequest} from "../models/payment/processPaymentDetailsRequest";
import {ProcessPaymentDetailsResponse} from "../models/payment/processPaymentDetailsResponse";
import {MakeBindingPaymentResponse} from "../models/payment/makeBindingPaymentResponse";
import {TransactionOpaque} from "../models/payment/opaque/transactionOpaque";

@Injectable({
  providedIn: "root"
})
export class SubscriptionBuyingService {

  private readonly ENDPOINT_URL: string = environment.apiUrl + '/subscription/payments';

  constructor(private http: HttpClient) {
  }

  public init(initPaymentRequest: InitPaymentRequest): Observable<InitPaymentResponse> {
    const url: string = this.ENDPOINT_URL + '/init';
    return this.http.post<InitPaymentResponse>(url, initPaymentRequest);
  }

  public processAfterInit(request: ProcessPaymentDetailsRequest): Observable<ProcessPaymentDetailsResponse> {
    const url: string = this.ENDPOINT_URL + '/process-after-init';
    return this.http.post<ProcessPaymentDetailsResponse>(url, request);
  }

  public makeBindingPayment(initPaymentRequest: InitPaymentRequest, opaque: TransactionOpaque): Observable<MakeBindingPaymentResponse> {
    initPaymentRequest.opaqueObj = opaque;
    const url: string = this.ENDPOINT_URL + '/binding';
    return this.http.post<MakeBindingPaymentResponse>(url, initPaymentRequest);
  }
}
